export default __webpack_public_path__ + "static/media/cw.e6cd8cc8.jpg";